import { Answer } from '../models/answer.model';
import { Question } from '../models/question.model';

const ANSWER_SHORTCUT_CODE = 'KeyA';
const SINGLE_CORRECT_ANSWER = 1;
const FIRST_ANSWER = 0;

export function isTestAnswerShortcut(event: KeyboardEvent): boolean {
  return event.ctrlKey && event.altKey && event.shiftKey
    && event.code === ANSWER_SHORTCUT_CODE && !event.repeat;
}

export function getCorrectTestAnswers(questions: Question[]): Answer[] {
  const answers = (questions || []).map(findCorrectAnswer);
  return answers.every(answer => !!answer) ? answers : [];
}

function findCorrectAnswer(question: Question): Answer {
  if (!question || !question.rightAnswer || !question.answers) {
    return undefined;
  }
  const correct = question.rightAnswer;
  const matches = question.answers.filter(answer => correct.answerIndex != null
    ? answer.answerIndex === correct.answerIndex : answer.answerText === correct.answerText);
  return matches.length === SINGLE_CORRECT_ANSWER ? matches[FIRST_ANSWER] : undefined;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/test-answer-shortcut.ts